<template>
  <div class="form-container mx-auto">
    <div
      class="card-top-tab mx-auto rounded-top"
      :class="`card-top-tab--${level} ${hideContent ? 'rounded-bottom' : ''}`"
    >
      <span v-if="isChapter" class="text-ternary">
        Chapitre {{ levelNumber }} -
      </span>
      <span class="text-white">
        {{ title }}
      </span>
    </div>
    <div v-if="!hideContent" class="card-content bg-light rounded mx-auto">
      <div class="row mx-auto">
        <slot />
      </div>
    </div>
    <div v-if="!hideButton" class="text-center">
      <div
        :class="getButtonStateClass()"
        class="btn btn-primary mx-auto rounded-0 rounded-bottom"
        v-bind="getButtonStateAttribute()"
        @click="emitButtonClick"
      >
        {{ buttonText }}
      </div>
    </div>
    <slot v-else name="buttons" />
  </div>
</template>

<script>
export default {
  props: {
    buttonText: {
      type: String,
      default: 'Continuer',
    },
    title: {
      type: String,
      required: true,
    },
    disableButton: {
      type: Boolean,
      default: false,
    },
    hideButton: {
      type: Boolean,
      default: false,
    },
    hideContent: {
      type: Boolean,
      default: false,
    },
    level: {
      type: String,
      default: 'section',
      required: true,
      validator(value) {
        return ['start', 'section', 'chapter', 'preamble'].includes(value)
      },
    },
    levelNumber: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isButtonDisabled: false,
      isButtonHidden: false,
    }
  },
  computed: {
    isChapter() {
      return this.level === 'chapter'
    },
  },
  methods: {
    emitButtonClick() {
      this.hideOrDisableButton()
      return this.$emit('click')
    },
    hideOrDisableButton() {
      if (this.isChapter) {
        this.isButtonHidden = true
        return
      }
      if (this.disableButton) {
        this.isButtonDisabled = true
        return
      }
    },
    getButtonStateClass() {
      if (this.isButtonHidden) {
        return 'd-none'
      }
      if (this.isButtonDisabled) {
        return 'disabled'
      }
      return null
    },
    getButtonStateAttribute() {
      if (this.isButtonHidden) {
        return { hidden: true }
      }
      if (this.isButtonDisabled) {
        return { disabled: true }
      }
      return null
    },
  },
}
</script>

<style lang="scss" scoped>
.form-container {
  width: 92%;
}
.card-top-tab {
  width: 97%;
  padding: 2rem 3rem;
  font-size: 1.5rem;
  line-height: 1em;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.141rem;
  &--section {
    background-color: var(--bs-secondary);
  }
  &--start,
  &--preamble,
  &--chapter {
    background-color: var(--bs-primary);
  }
}

.card-content {
  > div {
    width: 97%;
  }
}

.btn {
  padding: 1rem 5rem;
  font-size: 1.25rem;
  line-height: 1em;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.141rem;
}
</style>
